<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="工艺编码"><el-input v-model="query.routingCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="工序"><el-input v-model="query.processName" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="物料"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmOperationMaterial:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmOperationMaterial:save')" type="primary" size="small" @click="openDialog()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-alert class="scope-note" title="工序物料用于工艺用料参考；生产领料数量按工单下达时的 BOM 快照计算，此处维护不会自动改变领料需求。" type="info" :closable="false" show-icon />
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="routingCode" label="工艺编码" min-width="120" header-align="center" align="left" />
      <el-table-column prop="routingName" label="工艺名称" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="processName" label="工序" min-width="120" header-align="center" align="left" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" />
      <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="quantity" label="单位用量" width="100" header-align="center" align="right" />
      <el-table-column label="操作" width="140" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="isAuth('plm:plmOperationMaterial:update')" type="text" size="small" @click="openDialog(scope.row)">修改</el-button>
          <el-button v-if="isAuth('plm:plmOperationMaterial:delete')" type="text" size="small" @click="deleteHandle(scope.row.lineId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :title="saveForm.lineId ? '修改工序物料' : '新增工序物料'" :visible.sync="dialogVisible" width="min(560px, calc(100vw - 24px))" :close-on-click-modal="false">
      <el-form ref="saveFormRef" :model="saveForm" :rules="saveRules" label-width="100px">
        <el-form-item label="工艺" prop="routingId">
          <el-input :value="routingDisplay" readonly placeholder="点击选择工艺">
            <el-button slot="append" @click="routingSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="工序" prop="routingProcessId">
          <el-select v-model="saveForm.routingProcessId" placeholder="请先选择工艺" style="width:100%" :disabled="!processOptions.length">
            <el-option v-for="item in processOptions" :key="item.routingProcessId" :label="processOptionLabel(item)" :value="item.routingProcessId" />
          </el-select>
        </el-form-item>
        <el-form-item label="物料" prop="materialId">
          <el-input v-model="saveForm.materialCode" readonly>
            <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="单位用量" prop="quantity"><el-input v-model.trim="saveForm.quantity" placeholder="大于 0，最多 6 位小数" /></el-form-item>
      </el-form>
      <el-alert v-if="saveError" :title="saveError" type="warning" :closable="false" show-icon />
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
    <el-dialog title="选择工艺" :visible.sync="routingSelectorVisible" width="min(760px, calc(100vw - 24px))" append-to-body>
      <el-form :inline="true">
        <el-form-item label="工艺编码"><el-input v-model="routingQuery.routingCode" size="small" clearable style="width:140px" /></el-form-item>
        <el-form-item label="工艺名称"><el-input v-model="routingQuery.routingName" size="small" clearable style="width:140px" /></el-form-item>
        <el-form-item><el-button size="small" type="primary" @click="loadRoutingList">查询</el-button></el-form-item>
      </el-form>
      <el-table :data="routingList" border v-loading="routingLoading" :header-cell-style="headStyle">
        <el-table-column prop="routingCode" label="工艺编码" min-width="130" header-align="center" />
        <el-table-column prop="routingName" label="工艺名称" min-width="180" header-align="center" />
        <el-table-column label="操作" width="80" header-align="center" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" @click="onRoutingSelect(scope.row)">选择</el-button></template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector'

export default {
  name: 'PlmOperationMaterial',
  components: { MaterialSelector },
  data() {
    return {
      query: { routingCode: '', processName: '', materialCode: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, permCodes: [],
      dialogVisible: false, saving: false, saveError: '', materialSelectorVisible: false,
      routingSelectorVisible: false, routingLoading: false, routingList: [],
      routingQuery: { routingCode: '', routingName: '' },
      processOptions: [],
      saveForm: { routingId: '', routingCode: '', routingName: '', routingProcessId: '', materialId: '', materialCode: '', materialName: '', quantity: 1 },
      saveRules: {
        routingId: [{ required: true, message: '请选择工艺', trigger: 'change' }],
        routingProcessId: [{ required: true, message: '请选择工序', trigger: 'change' }],
        materialId: [{ required: true, message: '请选择物料', trigger: 'change' }],
        quantity: [{ required: true, validator: this.validateQuantity, trigger: 'blur' }]
      },
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  computed: {
    routingDisplay() {
      if (!this.saveForm.routingId) return ''
      const code = this.saveForm.routingCode || ''
      const name = this.saveForm.routingName || ''
      return name ? `${code} ${name}` : code
    },
    total() { return this.list.length },
    pageList() { return this.list.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  watch: {
    routingSelectorVisible(val) { if (val) this.loadRoutingList() }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    validateQuantity(rule, value, callback) {
      const text = String(value == null ? '' : value).trim()
      if (!/^(?:0|[1-9]\d{0,11})(?:\.\d{1,6})?$/.test(text) || Number(text) <= 0) {
        callback(new Error('单位用量须大于 0，最多 12 位整数和 6 位小数'))
      } else {
        callback()
      }
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.post('/plm/operation/list', this.query).then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    openDialog(row) {
      this.dialogVisible = true
      this.saveError = ''
      if (row) {
        this.saveForm = { ...row, quantity: row.quantity != null ? row.quantity : 1 }
        this.loadProcessOptions(row.routingId, row.routingProcessId)
      } else {
        this.saveForm = { routingId: '', routingCode: '', routingName: '', routingProcessId: '', materialId: '', materialCode: '', materialName: '', quantity: 1 }
        this.processOptions = []
      }
      this.$nextTick(() => { if (this.$refs.saveFormRef) this.$refs.saveFormRef.clearValidate() })
    },
    loadRoutingList() {
      this.routingLoading = true
      request.post('/base/routing/list', { currentPage: 1, pageSize: 50, routingCode: this.routingQuery.routingCode, routingName: this.routingQuery.routingName, isenabled: '0' })
        .then(res => { this.routingList = (res.data && res.data.list) || [] }).catch(() => { this.routingList = [] }).finally(() => { this.routingLoading = false })
    },
    onRoutingSelect(row) {
      this.saveForm.routingId = row.routingId
      this.saveForm.routingCode = row.routingCode
      this.saveForm.routingName = row.routingName
      this.saveForm.routingProcessId = ''
      this.routingSelectorVisible = false
      this.loadProcessOptions(row.routingId)
    },
    loadProcessOptions(routingId, keepProcessId) {
      if (!routingId) { this.processOptions = []; return }
      request.get(`/base/routing/info/${routingId}`).then(res => {
        const body = res.data || {}
        this.processOptions = body.lines || body.processList || []
        if (keepProcessId && this.processOptions.some(p => p.routingProcessId === keepProcessId)) {
          this.saveForm.routingProcessId = keepProcessId
        }
      }).catch(() => { this.processOptions = [] })
    },
    processOptionLabel(item) {
      const sort = item.sort != null ? `${item.sort}. ` : ''
      const name = item.processName || item.processCode || item.routingProcessId
      return `${sort}${name}`
    },
    onMaterialSelect(row) {
      this.saveForm.materialId = row.materialId
      this.saveForm.materialCode = row.materialCode
      this.saveForm.materialName = row.materialName
    },
    submit() {
      this.$refs.saveFormRef.validate(valid => {
        if (!valid) return
        this.saveError = ''
        this.saving = true
        const payload = {
          lineId: this.saveForm.lineId,
          routingId: this.saveForm.routingId,
          routingProcessId: this.saveForm.routingProcessId,
          materialId: this.saveForm.materialId,
          quantity: this.saveForm.quantity
        }
        const req = payload.lineId ? request.post('/plm/operation/update', payload) : request.post('/plm/operation/save', payload)
        req.then(() => { this.$message.success('保存成功'); this.dialogVisible = false; this.load() })
          .catch(err => { this.saveError = err.message || '保存失败' })
          .finally(() => { this.saving = false })
      })
    },
    deleteHandle(lineId) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/operation/delete', { lineId }).then(() => { this.$message.success('删除成功'); this.load() }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.scope-note { margin: 0 0 12px; }
</style>
